import { useContext, useEffect } from 'react';

import { AuthContext } from '../context-providers/AuthContext/AuthContext';
import { track } from '../utils/analytics/track';

const useStorageUserID = () => {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (user?.gid) {
      // Store user ID in session storage for GA4 tracking purposes.
      window.sessionStorage.setItem('user_id', user.gid);

      // Push user identification event to dataLayer
      track('user_identified', { user_id: user.gid });
    }
  }, [user]);
};

export default useStorageUserID;
